<template>
  <div class="auth-page">
    <div class="auth-card">
      <h2 class="auth-title">เข้าสู่ระบบผู้ดูแลระบบ</h2>
      
      <Form @submit="handleLogin" :validation-schema="loginSchema" v-slot="{ errors, isSubmitting }">
        <div class="form-group">
          <label for="username" class="form-label">ชื่อผู้ใช้</label>
          <Field
            id="username"
            name="username"
            type="text"
            class="form-input"
            :class="{ 'border-red-500': errors.username }"
            placeholder="กรอกชื่อผู้ใช้"
          />
          <ErrorMessage name="username" class="text-red-500 text-sm mt-1" />
        </div>
        
        <div class="form-group">
          <label for="password" class="form-label">รหัสผ่าน</label>
          <Field
            id="password"
            name="password"
            type="password"
            class="form-input"
            :class="{ 'border-red-500': errors.password }"
            placeholder="กรอกรหัสผ่าน"
          />
          <ErrorMessage name="password" class="text-red-500 text-sm mt-1" />
        </div>

        <button
          type="submit"
          :disabled="isSubmitting"
          class="btn btn-primary w-full"
        >
          <span v-if="isSubmitting" class="loading-spinner" style="width: 16px; height: 16px; margin-right: 8px;"></span>
          {{ isSubmitting ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ' }}
        </button>
      </Form>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAdminAuthStore } from '../../stores/adminAuth';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import { useNotification } from '../../composables/useNotification';

const router = useRouter();
const adminAuthStore = useAdminAuthStore();
const { showSuccess, handleApiError } = useNotification();

const loginSchema = yup.object({
  username: yup.string().required('กรุณากรอกชื่อผู้ใช้'),
  password: yup.string().required('กรุณากรอกรหัสผ่าน')
});

const handleLogin = async (values, { setErrors }) => {
  try {
    await adminAuthStore.login(values.username, values.password);
    showSuccess('เข้าสู่ระบบสำเร็จ!');
    router.push('/admin/dashboard');
  } catch (error) {
    handleApiError(error, setErrors);
  }
};
</script>

<style scoped>
.auth-page {
  /* Background gradient สบายตา สำหรับหน้า admin login */
  background: linear-gradient(
    135deg,
    #f9fafb 0%,
    #f3f4f6 50%,
    #ffffff 100%
  );
  position: relative;
}

.auth-page::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  /* Radial gradient overlay อ่อน ๆ */
  background: 
    radial-gradient(circle at 20% 30%, rgba(133, 94, 66, 0.02) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(212, 165, 116, 0.03) 0%, transparent 50%);
  z-index: 0;
}

.auth-card {
  position: relative;
  z-index: 1;
}

.border-red-500 {
  border-color: #ef4444 !important;
}

.text-red-500 {
  color: #ef4444;
}

.text-sm {
  font-size: 0.875rem;
}

.mt-1 {
  margin-top: 0.25rem;
}
</style>
